import { FarmerService } from "../services/Farmer";
import { Request } from "../services/Request";
import { urls } from "../Utils/Urls";


export const farmerData = async () => {

  // const farmerDBTResponse= await farmerDBTData(dbtId);
  const storedData = localStorage.getItem("farmer.farmerInfo");
  let tokenData;
  if (storedData)
    tokenData = JSON.parse(storedData);
  const farmerResponse = await FarmerService.login(tokenData?.uuid);
  return farmerResponse;
}
export const farmerDBTData = async (dbtId) => {

  const data = {
    Farmer: {
      dbtId,
    },
  };


  try {
    const citizenToken = localStorage.getItem("DfsWeb.access-token");
    const farmerInfoStr = localStorage.getItem("farmer.farmerInfo");
    let authToken = citizenToken;

    if (farmerInfoStr) {
      try {
        const farmerInfo = JSON.parse(farmerInfoStr);
        if (farmerInfo?.authToken) authToken = farmerInfo.authToken;
      } catch (e) {

      }
    }
    
    if (authToken) {

      data.RequestInfo = { authToken };
    } else {

    }

    const response = await Request({
      url: urls.DBTUserInfo,
      data: data,
      useCache: true,
      farmerLogin: true,
    });

    return { data: response.data };
  } catch (error) {

    return { error };
  }
};

